import { render, staticRenderFns } from "./BlindBoxList.vue?vue&type=template&id=b4d05066&scoped=true"
import script from "./BlindBoxList.vue?vue&type=script&lang=js"
export * from "./BlindBoxList.vue?vue&type=script&lang=js"
import style0 from "./BlindBoxList.vue?vue&type=style&index=0&id=b4d05066&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4d05066",
  null
  
)

export default component.exports